import React, { useContext, useState, useEffect } from 'react';
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import api from '../../connection/Axios';
import { Link } from 'react-router-dom';


const ListarNr = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [nrs, setNrs] = useState([])
  const [count, setCount] = useState(0)
  const [showNr, setShowNr] = useState(false)

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

  
    async function GetNrs() {
      api.get('nr/getNrs/', headers).then(response => {
        setNrs(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
    
    useEffect(()=>{
      GetNrs()
    }, [])


    async function DeleteNr(value) {
      await api.delete(`nr/deleteNr?number=${value}`, { headers }).then(response=>{
        GetNrs()
      })
    }
 
    return (
      <>
          <Layout breadcrumb='Dashboard / Normas Regulamentadoras / Listar Normas' title='Listar Normas'>
          <Typography>Normas Regulamentadoras cadastradas no sistema EHS</Typography>
            <br />
            <div style={styles.list}>
              
              {nrs?.map((comp, index)=>(
                <>
                  <Button onClick={()=>{setCount(index); setShowNr(!showNr)}} className='listItem' style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <div style={({width: 600, alignItems: 'flex-start', textAlign: 'left', justifyContent: 'flex-start'})}>
                      NR-{comp.number} - {comp.name}
                    </div>
                    <Button variant="outlined" disableElevation color="warning" size='small' component={Link} to="/adicionar-nr" state={{dados: comp}} style={{marginRight: 5}}>Editar</Button>
                    <Button variant="outlined" disableElevation color="error" size='small' onClick={()=>{DeleteNr(comp.number)}}>Remover</Button>
                  </Button>
                  {showNr && count === index ?
                    <div style={{padding: 20, marginBottom: 20}}>
                      {(comp.items).map((item, index)=>(
                        <div style={{padding: 5}}>
                          {item.documento}
                        </div>
                      ))}
                    </div>
                    : null }
                </>
              ))}
            </div>
          </Layout>
      </>
    );
}

export default ListarNr

const styles = {
  list: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 20
  }
}